import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed, useSlots } from 'vue';
var __default__ = {
    name: 'XBadge'
};
export default /*#__PURE__*/ _defineComponent(_object_spread_props(_object_spread({}, __default__), {
    props: {
        content: [
            Number,
            String
        ],
        dot: Boolean,
        max: {
            type: Number,
            default: 99
        },
        color: {
            type: String,
            default: '#FF4846'
        },
        offsetX: {
            type: String,
            default: '50%'
        },
        offsetY: {
            type: String,
            default: '-50%'
        },
        scale: {
            type: Number,
            default: 1
        }
    },
    setup: function setup(__props) {
        var props = __props;
        var slots = useSlots();
        /**
 * 是否自定义内容
 */ var hasContent = computed(function() {
            return slots.content || props.content != null && props.content !== '';
        });
        /**
 * badge样式
 */ var badgeStyle = computed(function() {
            return {
                transform: "translate(".concat(props.offsetX, ", ").concat(props.offsetY, ") scale(").concat(props.scale, ")"),
                backgroundColor: props.color
            };
        });
        /**
 * 格式化内容
 * 当内容为数值类型时则限制最大显示数值，否则不做任何处理
 */ var formatContent = function formatContent(content) {
            if (typeof content === 'number' && isFinite(content) && isFinite(props.max)) {
                return content > props.max ? "".concat(props.max, "+") : content;
            }
            return content;
        };
        return {
            __sfc: true,
            props: props,
            slots: slots,
            hasContent: hasContent,
            badgeStyle: badgeStyle,
            formatContent: formatContent
        };
    }
}));
